import __request__ from "routing/request";
export function listCredentials(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/athena/credentials", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listRegions(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.datalake/athena/credentials/regions", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function save(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.datalake/athena/credentials/save", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function credentialDetails(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.datalake/athena/credentials/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteCredentials(id, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.datalake/athena/credentials/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
